import axios from 'axios';

const refreshToken = async () => {

  return axios.create().post('/refresh-beyond-token');
}

export default refreshToken;
